import {
  DELETE_VOLCANO_LOCATION_REQUEST,
  CLEAR_VOLCANO_LOCATION_DATA,
  GET_VOLCANO_LOCATION_DATA_REGION_REQUEST,
  VOLCANO_LOCATION_DATA_BULK_EDIT_REQUEST,
  VOLCANO_LOCATION_DATA_CANCEL_EDIT,
  VOLCANO_LOCATION_DATA_EDIT,
  VOLCANO_LOCATION_DATA_SAVE_CANCEL_CONFIRMATION,
  VOLCANO_LOCATION_DATA_SAVE_OPEN_CONFIRMATION,
  VOLCANO_LOCATION_DATA_TOGGLE_COLUMN,
} from './volcanoLocationDataReducer';
import { VOLCANO_LOCATION_DATA_SORT } from '../search/volcanoLocationSearchReducer';

export const deleteVolcanoLocation = ({ id, history }) => ({
  type: DELETE_VOLCANO_LOCATION_REQUEST,
  id,
  history,
});

export const clearVolcanoEventData = () => ({ type: CLEAR_VOLCANO_LOCATION_DATA });
export const getRegions = ({ history }) => ({ type: GET_VOLCANO_LOCATION_DATA_REGION_REQUEST, history });
export const sortData = sort => ({ type: VOLCANO_LOCATION_DATA_SORT, sort });
export const toggleColumns = visibleColumns => ({ type: VOLCANO_LOCATION_DATA_TOGGLE_COLUMN, visibleColumns });
export const bulkEditVolcanoLocations = ({ data }) => ({ type: VOLCANO_LOCATION_DATA_BULK_EDIT_REQUEST, data });
export const openEditConfirmation = ({ formData, initialFormData }) => ({ type: VOLCANO_LOCATION_DATA_SAVE_OPEN_CONFIRMATION, formData, initialFormData });
export const cancelEditConfirmation = () => ({ type: VOLCANO_LOCATION_DATA_SAVE_CANCEL_CONFIRMATION });
export const startEdit = ({ initialValues }) => ({ type: VOLCANO_LOCATION_DATA_EDIT, initialValues });
export const cancelEdit = () => ({ type: VOLCANO_LOCATION_DATA_CANCEL_EDIT });
